<!--
 * @Description:护眼常识页面从小学那边迁移过来的
 * @Version: 1.0.3
 * @Autor: chen wei
 * @Date: 2020-04-14 18:47:27
 * @LastEditors: liujinlei liujinlei@zhihuiliu.com
 * @LastEditTime: 2023-11-30 09:59:09
 -->
<template>
  <div class="conten-box"
       v-if="queryNum <= 0">
    <van-nav-bar v-if="!hideHeader"
                 class="header"
                 :title="title"
                 :border="false"
                 @click-left="onClickClose">
      <template #left>
        <van-icon :name='require("@/assets/images/oralExpression/icon-close.png")'
                  size="22" />
      </template>
    </van-nav-bar>
    <div class="cont">

      <div class="progress"
           v-if="!hideHeader">
        <van-progress :percentage="percentage"
                      :show-pivot="false"
                      color="#45D585"
                      stroke-width="4" />
      </div>

      <div class="wapper"
           ref="wapper"
           :style='"padding-bottom:"+ paddingBottom +"px;"'>
        <div class="w-title"
             ref="title">
          <span class="tag">角色扮演</span>
          <div class="msg"
               @click="exchangeTypeFun">
            <van-icon :name='require("@/assets/images/oralExpression/icon-exchange.png")'
                      size="22" />
            {{ exchangeType ? "练习模式" : "表达模式"}}
          </div>
        </div>
        <div class="msg-box"
             ref="msgBox">
          <!-- <div class="act">Hi, 现在你扮演角色A-Alice</div> -->
          <message :ref="'message-'+ i"
                   v-for="(item, i) in messageList"
                   :key="i"
                   :readData="item"
                   @setScroll="setScrollFun"
                   @readThisMessage="readThisMessageFun"
                   @readThisMessageYuan="readThisMessageYuanFun"
                   @selectThis="selectThisFun"
                   @reluyin="reluyinFun" />
        </div>
      </div>
    </div>
    <!-- 练习模式 -->
    <div class="footer"
         v-if="exchangeType == 1"
         v-show="!hideFooter">
      <div class="footer-item">
        <van-icon v-if="isPlaying"
                  :name='require("@/assets/images/oralExpression/icon-fanish-disable.png")'
                  size="40" />
        <van-icon v-else
                  @click="fanish"
                  :name='require("@/assets/images/oralExpression/icon-fanish.png")'
                  size="40" />
        <div class="name">完成</div>
      </div>
      <div class="footer-item">
        <van-icon v-if="isPlaying || !askLuyin"
                  :name='require("@/assets/images/oralExpression/icon-luyin-disable.png")'
                  size="92" />
        <van-icon v-else
                  @click="send"
                  :name='require("@/assets/images/oralExpression/icon-luyin.png")'
                  size="92" />
        <div class="name">{{ theName }}</div>
      </div>
      <div class="footer-item">
        <van-icon v-if="isPlaying || currentIndex == messageList.length"
                  :name='require("@/assets/images/oralExpression/icon-next-disable.png")'
                  size="40" />
        <van-icon v-else-if="currentIndex == 0"
                  @click="aiSend(0)"
                  :name='require("@/assets/images/oralExpression/icon-next.png")'
                  size="40" />
        <van-icon v-else
                  @click="nextReading"
                  :name='require("@/assets/images/oralExpression/icon-next.png")'
                  size="40" />
        <div class="name">{{currentIndex == 0 ?"开始":"下一句"}}</div>
      </div>
    </div>
    <!-- 表达模式 -->
    <div class="footer"
         v-else-if="exchangeType == 0"
         v-show="!hideFooter">
      <div class="footer-item">
        <van-icon v-if="percentage != 100 || theNoAnswer.length"
                  :name='require("@/assets/images/oralExpression/icon-fanish-disable.png")'
                  size="40" />
        <van-icon v-else
                  @click="fanish"
                  :name='require("@/assets/images/oralExpression/icon-fanish.png")'
                  size="40" />
        <div class="name">完成</div>
      </div>
      <div class="footer-item">
        <van-icon v-if="!askLuyin"
                  :name='require("@/assets/images/oralExpression/icon-luyin-disable.png")'
                  size="92" />
        <van-icon v-else
                  @click="send"
                  :name='require("@/assets/images/oralExpression/icon-luyin.png")'
                  size="92" />
        <div class="name">{{ theName }}</div>
      </div>
      <div class="footer-item">
        <van-icon v-if="currentIndex != 0 || isPlaying"
                  :name='require("@/assets/images/oralExpression/icon-next-disable.png")'
                  size="40" />
        <van-icon v-else
                  @click="nextReading"
                  :name='require("@/assets/images/oralExpression/icon-next.png")'
                  size="40" />
        <div class="name">开始</div>
      </div>
    </div>
    <div class="asklu"
         v-show="isLuing"
         @click="stopLu">
      <div class="waveBox">
        <WaveView />
      </div>
      <div class="text">点击波纹，结束录音</div>
    </div>
    <div class="player">
      <!-- <aplayer class="myAudio"
        ref="aplayer"
        theme="#5A95FD"
        loop="none"
        @timeupdate="playingFun"
        @ended="playEnd"
        @error="playError"
        :audio="currentMusic" /> -->
      <audio :src="currentMusic.url"
             type='wav'
             @timeupdate="playingFun"
             @ended="playEnd"
             @error="playError"
             :loop="false"
             ref="aplayer"
             controls="controls"></audio>
    </div>
    <getVipTip :show="showGetVipAlert && !hideHeader"
               title="欢迎使用口语表达功能"
               @getVip="getVipFun"
               @close="showGetVipAlert = false" />
    <closeOral :show="showCloseOral"
               :type="closeOralType"
               @nextClick="goToNextMoudle"
               @close="showCloseOral = false" />
    <OralExpressionF :show="showOralExpressionF"
                     @close="showOralExpressionF = false" />
  </div>
</template>

<script>
import {
  jumpWebView,
  HttpFactory,
  getArgs,
  iosOrAndroid,
  zhlType
} from '@/assets/js/common'
// import { getArgs } from '@/assets/js/common'
import rqParams from './rq.js'
import '@/assets/js/engine.js'
// import Oral from '@/assets/js/zhloralMain.js'
import OralweChat from '@/assets/js/zhlOralweChat.js'
import message from '@/components/Message/index'
import getVipTip from '@/components/OralExpressionComponents/OralExpressionGetVip'
import closeOral from '@/components/OralExpressionComponents/OralExpressionClose'
import OralExpressionF from '@/components/OralExpressionComponents/OralExpressionF'
import WaveView from '@/components/EnglishComponents/WaveView'
import { iseRecorder } from '@/assets/js/kdxf'
let lastTime = 0
export default {
  name: 'analogFollowUpReading',
  components: {
    message,
    getVipTip,
    closeOral,
    WaveView,
    OralExpressionF
  },
  props: {
    theGuid: {
      type: String,
      default: ''
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    questionItem: {
      type: Object
    }
  },
  data() {
    return {
      business_id: null,
      showOralExpressionF: false,
      isIOSWx: false,
      access_token: '',
      refText: '',
      isRoot: false,

      isLuing: false,
      hideFooter: false,
      showGetVipAlert: false,
      showCloseOral: false,
      closeOralType: 'close',
      queryNum: 0,
      title: '',
      listArr: [],
      isShowGetVip: false,
      currentIndex: 0,
      currentObj: {
        isPlaying: false
      },
      percentage: 0, // 进度条
      messageList: [], // 消息队列
      currentMusic: {
        name: '',
        artist: '',
        url: ''
      },
      paddingBottom: 0,
      height: 0,
      timer: null,
      timer2: null,
      timer3: null,
      askLuyin: false, // 重新录音
      rePlaying: false, // 重听
      isPlaying: false, // 全局的播放状态
      theName: '点击录音',
      userInfo: {},
      exchangeType: 0, // 1练习模式 0表达模式
      nextList: [],
      guid: '',
      book_id: '',
      resource_id: '',
      model_id: '',
      type: '',
      pageType: 1 // 目前写死的页码模式，还有一个目录模式
    }
  },
  watch: {
    currentIndex(val) {
      if (!this.messageList.length) {
        return
      }
      const num = parseInt((val / this.messageList.length) * 100)
      const oldNum = this.percentage
      this.numFun(oldNum, num, data => {
        this.percentage = data
      })
      if (val == 0) {
        return
      }
      const el = this.$refs['message-' + (val - 1)][0].$el
      const parentNode = el.parentNode
      const container = this.$refs.wapper
      const title = this.$refs.title
      const offsetTop = el.offsetTop - parentNode.offsetTop
      if (title.clientHeight + offsetTop + el.clientHeight >= container.clientHeight) {
        const oldTop = container.scrollTop
        const newTop = title.clientHeight + offsetTop + el.clientHeight - container.clientHeight + 20
        this.numFun(oldTop, newTop, data => {
          container.scrollTop = data
        })
      }
    },
    currentObj(val) {
      if (this.rePlaying) {
        return
      }
      this.currentMusic.url = val.url || val.sysUrl
      // if (this.currentIndex == 0 && this.exchangeType == 0) {
      //   return
      // }
      this.isPlaying = true
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.$refs.aplayer.play()
      }, 100)
    },
    questionItem(obj) { }
  },
  computed: {
    theNoAnswer() {
      return this.messageList.filter(el => {
        return el.url == ''
      })
    }
  },
  created() {
    window.oralRecAndEvaCallback = this.oralRecAndEvaCallback
  },
  mounted() {
    const param = getArgs()
    this.guid = this.theGuid || param.guid
    this.book_id = param.book_id || 0
    this.resource_id = param.resource_id
    this.model_id = param.model_id
    this.title = param.title
    this.type = param.type
    this.business_id = Number(zhlType.getBusinessId())
    this.getUserInfo()
    this.getNextList()
    jumpWebView.handleNavigator(false)
    if (typeof zhlWebView != 'undefined') {
      try {
        zhlWebView.setBouncesEnabled(0) // 禁用ios回弹
      } catch (error) { }
    }
    if (iosOrAndroid() == 'ios') {
      var ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        // 是微信打开
        this.isIOSWx = true
        this.getweixinjsapiconfigFun()
      } else {
        this.$toast('请使用微信扫码打开，否则无法录音')
        // Oral.initEngine()
      }
    } else {
      // Oral.initEngine()
    }
    iseRecorder.onTextChange = this.oralRecAndEvaCallback
    // 录音权限
    iseRecorder.recorderInit()
  },
  methods: {
    getweixinjsapiconfigFun() {
      const url = location.href
      HttpFactory.postUrlPay(
        rqParams.getweixinjsapiconfig({
          app_id: 137,
          url: url
        }),
        res => {
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.data.app_id, // 必填，公众号的唯一标识
            timestamp: res.data.time_stamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonce_str, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名
            jsApiList: ['startRecord', 'stopRecord', 'uploadVoice'] // 必填，需要使用的JS接口列表
          })
          wx.ready(() => {
            this.isRoot = true
          })
        }
      )
    },
    beginLu(msg) {
      if (this.isIOSWx) {
        if (this.isRoot) {
          wx.startRecord()
          this.isLuing = true
          this.refText = msg
        } else {
          this.$toast('麦克风没有被允许')
        }
        return
      }
      // if (!Oral.isRoot) {
      //   this.$toast('麦克风没有被允许')
      //   return
      // }
      this.isLuing = true
      // Oral.myRecord.startRecord({
      //   coreType: 'en.sent.score',
      //   refText: msg,
      //   rateScale: 1.0,
      //   symbol: 1,
      //   attachAudioUrl: 1,
      //   evalTime: null
      // })
      iseRecorder.recorderInit({
        text: msg
      })
    },
    stopLu() {
      if (this.isIOSWx) {
        const that = this
        wx.stopRecord({
          success(res) {
            var localId = res.localId
            wx.uploadVoice({
              localId: localId, // 需要上传的音频的本地ID，由stopRecord接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success(res) {
                var serverId = res.serverId // 返回音频的服务器端ID
                console.log(serverId)
                that.getUrlAndPing(serverId)
              }
            })
          }
        })
      } else {
        // Oral.myRecord.stopRecord()
        this.isLuing = false
        iseRecorder.stop()
      }
    },
    getUrlAndPing(id) {
      const jsonText = OralweChat.getEvalJson('wechat', this.refText, 'en.sent.score')
      const timestamp = parseInt(new Date().getTime() / 1000) + ''
      const message = 'a658.' + timestamp + '.JSWsbEHxIvTnqPy5oZ7GOzF9LKBNr1UM'
      const sig = OralweChat.sha1(message)
      jsonText.connect.param.app.timestamp = timestamp
      jsonText.connect.param.app.sig = sig
      jsonText.start.param.app.timestamp = timestamp
      jsonText.start.param.app.sig = sig
      HttpFactory.postUrlPay(
        rqParams.getweixinvoicetestinfo({
          media_id: id,
          app_id: 137,
          json_text: JSON.stringify(jsonText),
          is_login: 1
        }),
        res => {
          this.isLuing = false
          const data = JSON.parse(res.data)
          const resultData = {}
          resultData.overall = data.result.overall
          resultData.duration = data.result.wavetime / 1000
          resultData.audioUrl = data.audioUrl
          resultData.resultStr = data.refText
          resultData.wordInfosArr = []
          const arr = data.result.details
          arr.forEach(el => {
            resultData.wordInfosArr.push({
              word: el.char,
              score: el.score
            })
          })
          this.oralRecAndEvaCallback(JSON.stringify(resultData))
        }
      )
    },
    initEvent() {
      window.oralRecAndEvaCallback = this.oralRecAndEvaCallback
    },
    oralRecAndEvaCallback(param) {
      this.hideFooter = false
      var data = JSON.parse(param)
      // const isVip = !!(this.userInfo.member_type && this.userInfo.member_type != 1)
      let str = ''
      try {
        str = this.getTheResultStr(data)
      } catch (error) {
        str = '语音识别失败'
      }
      const activeBookInfo = sessionStorage.getItem('activeBookInfo')
      let book_name = ''
      if (activeBookInfo) {
        const { name } = JSON.parse(activeBookInfo)
        book_name = name || ''
      }
      this.messageList.forEach((el, i) => {
        if (el.isAskLuyin) {
          const obj = Object.assign({}, el)
          obj.type = 'right'
          obj.url = data.audioUrl
          obj.audio_duration = data.duration
          obj.grade = data.overall
          obj.msg = str
          obj.isAskLuyin = false
          obj.isPlaying = true
          iseRecorder.setAudioUrl(obj, {
            formDataBack: (formData) => {
              formData.append('file_path_key', book_name)
            }
          })
          this.currentObj = obj
          this.isPlaying = true
          this.messageList.splice(i, 1, this.currentObj)
          if (!el.isVip && !this.isShowGetVip) {
            this.messageList.splice(i + 1, 0, {
              type: 'other',
              msg: '想要查看自己的表达情况吗？',
              expressionType: 1
            })
            this.isShowGetVip = true
          }
          this.askLuyin = false
        }
      })
    },
    getTheResultStr(data) {
      var srt = ''
      var obj = {}
      data.wordInfosArr.forEach(el => {
        srt += el.word + '|'
        if (el.score >= 60) {
          obj[el.word] = '<span class="green">' + el.word + '</span>'
        } else {
          obj[el.word] = '<span class="red">' + el.word + '</span>'
        }
      })
      srt = srt.slice(0, srt.length - 1)
      try {
        const reg = new RegExp('(' + srt + ')', 'gi')
        const newLine = data.resultStr.replace(reg, ($0, $1) => {
          return (obj[$1] || obj[$1.toLowerCase()]) ? (obj[$1] || obj[$1.toLowerCase()]) : $0
        })
        return newLine
      } catch (error) {
        return data.resultStr
      }
    },
    getUserInfo() {
      HttpFactory.postUrl(rqParams.getusermemberinfo(), res => {
        this.userInfo = Object.assign(this.userInfo, res.data)
        if (this.userInfo.member_type && this.userInfo.member_type != 1) {
          // 说明是会员
        } else {
          // HttpFactory.postUrl(
          //   rqParams.getrewardresult({
          //     type: 20
          //   }),
          //   res => {
          //     if (res.data.if_pop) {
          //       // 没有领取过
          //       this.showGetVipAlert = true
          //     }
          //   }
          // )
        }
        HttpFactory.postUrl(rqParams.getstudentinfo(), res => {
          this.userInfo = Object.assign(this.userInfo, res.data)
          this.getDataList()
        })
      })
    },
    // 领取免费7天会员
    getVipFun() {
      HttpFactory.postUrl(
        rqParams.submitreceivereward({
          type: 20
        }),
        res => {
          if (res.code == 0) {
            this.$toast('领取成功')
          }
          this.getUserInfo()
          this.showGetVipAlert = false
        }
      )
    },
    // 数字动画
    numFun(startNum, maxNum, fn, speed = 1) {
      let numText = startNum
      let golb // 为了清除requestAnimationFrame
      function numSlideFun() {
        // 数字动画
        numText += speed // 速度的计算可以为小数 。数字越大，滚动越快
        if (numText >= maxNum) {
          numText = maxNum
          cancelAnimationFrame(golb)
        } else {
          golb = requestAnimationFrame(numSlideFun)
        }
        fn(numText)
        // console.log(numText)
      }
      numSlideFun() // 调用数字动画
    },
    requestAnimationFrame(fn) {
      const currTime = new Date().getTime()
      // 为了使setTimteout的尽可能的接近每秒60帧的效果
      const timeToCall = Math.max(0, 16 - (currTime - lastTime))
      const id = window.setTimeout(() => {
        fn(currTime + timeToCall)
      }, timeToCall)
      lastTime = currTime + timeToCall
      return id
    },
    cancelAnimationFrame(id) {
      window.clearTimeout(id)
    },

    exchangeTypeFun() {
      if (this.isPlaying) {
        this.$toast('播放过程中无法切换')
        return
      }
      this.currentIndex = 0
      this.isShowGetVip = false
      this.askLuyin = false
      this.percentage = 0
      this.messageList = []
      this.exchangeType = this.exchangeType ? 0 : 1
      setTimeout(() => {
        this.getDataList(() => {
          this.$toast('模式已经切换为' + (this.exchangeType ? '练习模式' : '表达模式'))
        })
      }, 500)
    },
    playError() {
      if (this.messageList.length) {
        this.$toast('播放失败')
      }
    },
    playEnd() {
      this.currentObj.isPlaying = false
      this.isPlaying = false
      this.askLuyin = false
      if (this.exchangeType == 0 && this.currentIndex != 0) {
        const obj = this.messageList[this.currentIndex - 1]
        if (!obj.url) {
          obj.isAskLuyin = true
          this.askLuyin = true
        }
      }
      if (!this.rePlaying && this.exchangeType == 0) {
        if (this.currentIndex == this.messageList.length) {
          this.rePlaying = false
          return
        }
        const obj = this.messageList[this.currentIndex - 1]
        if (!obj.url) {
          obj.isAskLuyin = true
          this.askLuyin = true
        } else {
          this.nextReading()
        }
      }
      this.rePlaying = false
    },
    // 播放和暂停
    playingFun() {
      // const { media } = this.$refs.aplayer
      // this.currentObj.isPlaying = !media.paused
      // this.isPlaying = !media.paused
      this.currentObj.isPlaying = true
      this.isPlaying = true
    },
    // 重新听
    readThisMessageFun(obj) {
      this.rePlaying = true
      this.messageList.forEach(el => {
        el.isPlaying = false
        if (el.isAskLuyin) {
          el.isAskLuyin = false
          this.askLuyin = false
        }
      })
      this.currentObj = obj
      this.currentMusic.url = obj.url + '?time=' + new Date().getTime()
      setTimeout(() => {
        this.$refs.aplayer.play()
      }, 100)
    },
    // 重新系统原音频
    readThisMessageYuanFun(obj) {
      this.rePlaying = true
      this.messageList.forEach(el => {
        el.isPlaying = false
        if (el.isAskLuyin) {
          el.isAskLuyin = false
          this.askLuyin = false
        }
      })
      this.currentObj = obj
      this.currentMusic.url = obj.sysUrl + '?time=' + new Date().getTime()
      setTimeout(() => {
        this.$refs.aplayer.play()
      }, 100)
    },
    selectThisFun(obj) {
      if (this.exchangeType == 0) {
        return
      }
      this.messageList.forEach((el, i) => {
        if (obj.id == el.id) {
          this.currentIndex = i + 1
        }
        el.isPlaying = false
        el.isAskLuyin = false
      })
      this.$refs.aplayer.pause()
      this.rePlaying = false
      obj.isAskLuyin = true
      this.askLuyin = true
    },
    reluyinFun(obj) {
      if (this.isPlaying) {
        this.$toast('播放过程中无法重新录音')
        return
      }
      // if (this.askLuyin) {
      //   this.$toast('请先完成上一次的对话')
      //   return
      // }
      this.messageList.forEach(el => {
        el.isAskLuyin = false
      })
      obj.isAskLuyin = true
      this.askLuyin = true
      this.$toast({
        message: '点击录音，重新录制',
        position: 'bottom',
        className: 'zhl-toast-bottom' + (this.theGuid ? ' more' : ''),
        duration: 1000
      })
      this.theName = '重新录音'
    },
    setScrollFun(el) { },
    // 点击关闭
    onClickClose() {
      this.showCloseOral = true
      this.closeOralType = 'close'
    },
    // 点击完成
    fanish() {
      if (this.theGuid && JSON.stringify(this.questionItem) != '{}') {
        this.$emit('fanished', 'next')
        this.questionItem.if_right = 2
      } else {
        this.showCloseOral = true
        this.closeOralType = 'all'
      }
    },
    goToNextMoudle() {
      const nextList = this.deal(JSON.parse(JSON.stringify(this.nextList)), node => {
        return node.model_list.length > 0
      })
      const arr = []
      nextList.forEach((el, i) => {
        arr.push(...el.model_list)
      })
      let item = null
      arr.forEach((el, i) => {
        if (el.model_id == this.model_id) {
          item = arr[i + 1]
        }
      })
      if (item) {
        const parent = this.deal(JSON.parse(JSON.stringify(this.nextList)), node => {
          return JSON.stringify(node.model_list).indexOf(JSON.stringify(item)) > -1
        })
        const data = {
          item,
          parent: parent[0]
        }
        this.goDetailFun(data)
        // this.goqusDetailFun(qus)
      } else {
        this.showCloseOral = false
        this.showOralExpressionF = true
      }
    },
    goDetailFun(data) {
      HttpFactory.postUrl(
        rqParams.submitbookstudyrecord({
          book_id: this.book_id,
          type: data.parent.type + 1,
          study_type: 1,
          study_id: data.item.model_id,
          resource_id: data.parent.resource_id
        }),
        (res) => { }
      )
      HttpFactory.postUrl(
        rqParams.getmodelinfo({
          model_id: data.item.model_id
        }),
        (res) => {
          const paper_list = res.data.paper_list || []
          if (paper_list.length > 0) { // 进入试卷模式
            location.href = './EnglishPaperTest.html?title=' + data.parent.resource_name + '&book_id=' + this.book_id + '&type=' + data.parent.type + '&resource_id=' + data.parent.resource_id + '&model_id=' + data.item.model_id + `&business_id=${this.business_id}`
          } else {
            this.goqusDetailFun(res.data.question_list[0], data)
          }
        }
      )
    },
    deal(nodes, predicate) {
      // 如果已经没有节点了，结束递归
      if (!(nodes && nodes.length)) {
        return []
      }
      const newChildren = []
      for (const node of nodes) {
        if (predicate(node)) {
          // 如果节点符合条件，直接加入新的节点集
          newChildren.push(node)
          node.children = this.deal(node.children_list, predicate)
        } else {
          // 如果当前节点不符合条件，递归过滤子节点，
          // 把符合条件的子节点提升上来，并入新节点集
          newChildren.push(...this.deal(node.children_list, predicate))
        }
      }
      return newChildren
    },
    goqusDetailFun(qus, data) {
      if (!qus) {
        this.$toast('跳转失败，请直接退出')
        return
      }
      if (qus.sub_model_id == 5) {
        location.href = './EnglishListeningQuestions.html?guid=' + qus.guid + '&title=' + data.parent.resource_name + '&book_id=' + this.book_id + '&type=' + data.parent.type + '&resource_id=' + data.parent.resource_id + '&model_id=' + data.item.model_id + `&business_id=${this.business_id}`
        return
      }
      if (qus.model_id === 11) {
        if (qus.sub_model_id == 1) {
          location.href = './EnglishAnalogFollowUpReading.html?guid=' + qus.guid + '&title=' + data.parent.resource_name + '&book_id=' + this.book_id + '&type=' + data.parent.type + '&resource_id=' + data.parent.resource_id + '&model_id=' + data.item.model_id + `&business_id=${this.business_id}`
        } else if (qus.sub_model_id == 2) {
          location.href = './EnglishOralExpression.html?guid=' + qus.guid + '&title=' + data.parent.resource_name + '&book_id=' + this.book_id + '&type=' + data.parent.type + '&resource_id=' + data.parent.resource_id + '&model_id=' + data.item.model_id + `&business_id=${this.business_id}`
        } else if (qus.sub_model_id == 3) {
          location.href = './EnglishOralAnswerQuestions.html?guid=' + qus.guid + '&title=' + data.parent.resource_name + '&book_id=' + this.book_id + '&type=' + data.parent.type + '&resource_id=' + data.parent.resource_id + '&model_id=' + data.item.model_id + `&business_id=${this.business_id}`
        } else if (qus.sub_model_id == 4) {
          location.href = './EnglishOralExpressionTraining.html?guid=' + qus.guid + '&title=' + data.parent.resource_name + '&book_id=' + this.book_id + '&type=' + data.parent.type + '&resource_id=' + data.parent.resource_id + '&model_id=' + data.item.model_id + `&business_id=${this.business_id}`
        }
      } else {
        setTimeout(() => {
          this.$toast('题目信息不正确')
        }, 800)
      }
    },
    getNextList() {
      HttpFactory.postUrl(
        rqParams.getlistenspeakinfov2({
          book_id: this.book_id
        }),
        res => {
          this.nextList = res.data.catalog_list
        }
      )
    },
    // 发送
    send() {
      this.messageList.forEach((el, i) => {
        if (el.isAskLuyin) {
          const dataFormApp = Object.assign({}, el)
          let msgs = dataFormApp.sysText.replace(/<.*?>/gi, '')
          msgs = this.replaceKun(msgs)
          this.beginLu(msgs)
          // var json = { oralText: msgs }
          // var str = JSON.stringify(json)

          // // 调用语音评测
          // if (typeof zhlWebView != 'undefined') {
          //   if (this.theGuid) {
          //     this.hideFooter = true
          //   }
          //   zhlWebView.oralEvaluation(str)
          // }
        }
      })
    },
    nextReading() {
      if (this.exchangeType) {
        this.messageList.forEach(el => {
          el.isPlaying = false
          el.isAskLuyin = false
        })
        this.aiSend()
      } else {
        const obj = this.messageList[this.currentIndex]
        if (obj.type == 'right') {
          this.$toast({
            message: '点击录音，进行对话',
            position: 'bottom',
            className: 'zhl-toast-bottom' + (this.theGuid ? ' more' : ''),
            duration: 1000
          })
          this.theName = '点击录音'
          this.askLuyin = true
          obj.isAskLuyin = true
        } else if (obj.type == 'left') {
          this.currentObj = {}
          this.currentObj = obj
        } else {
          // other类型的数据跳过
          this.currentIndex++
          const newObj = this.messageList[this.currentIndex]
          this.currentObj = newObj
        }
        this.currentIndex++
      }
    },
    aiSend() {
      if (this.isPlaying) {
        return
      }
      this.isPlaying = true
      const obj = this.messageList[this.currentIndex]
      if (this.currentIndex == 0) {
        this.currentObj = obj
        this.$refs.aplayer.play()
      } else if (obj.id == this.currentObj.id || obj.type == 'other') {
        this.currentIndex++
        const newObj = this.messageList[this.currentIndex]
        this.currentObj = newObj
      } else {
        this.currentObj = obj
      }
      this.currentIndex++
    },
    // 以下为初始化数据
    getDataList(fn) {
      HttpFactory.postUrl(
        rqParams.getquestioninfo({
          guid: this.guid
        }),
        res => {
          const obj = JSON.parse(res.data.options)
          const dataArr = obj.data
          const roleArr = obj.role
          // this.title = res.data.stem.replace(/<.*?>/gi, '')
          dataArr.forEach(el => {
            roleArr.forEach(sub => {
              if (el.extra.avatar_id == sub.avatar_id) {
                el.extra = Object.assign(el.extra, sub)
              }
            })
          })
          this.listArr = obj.data
          this.listArr.forEach((el, i) => {
            el.option = this.replaceKun(el.option)
            if (el.extra.if_user == 1) {
              // 模拟口语表达数据
              el.type = 'right'
              this.getMessage(el)
            } else {
              el.type = 'left'
              this.getMessage(el)
            }
          })
          this.currentIndex = 0
          // this.currentMusic.url = this.messageList[0].url || this.messageList[0].sysUrl
          this.isPlaying = false
          if (fn) {
            fn()
          }
        }
      )
    },
    replaceKun(str) {
      return str.replace(/{_.*?_}/gi, s1 => {
        const result = s1.split('_')
        return result[1]
      })
    },
    getMessage(data) {
      // const isVip = !!(this.userInfo.member_type && this.userInfo.member_type != 1)
      const isVip = true
      if (data.type == 'left') {
        const obj = {
          url: data.extra.audio_url,
          audio_duration: data.extra.audio_duration,
          avatar_url: data.extra.avatar_url,
          avatar_name: data.extra.avatar_name,

          type: 'left',
          msg: data.option,
          isPlaying: false,
          isShowText: !!this.exchangeType,
          // 口语表达新增参数
          expressionType: 1, // 是口语表达角色扮演
          nowExchangeType: this.exchangeType
        }
        this.messageList.push(obj)
        return
      }
      if (isVip) {
        const obj = {
          id: new Date().getTime() + Math.random(),
          url: '',
          audio_duration: data.extra.audio_duration,
          avatar_url: this.userInfo.avatar_url,
          avatar_name: data.extra.avatar_name,
          isVip: true,
          type: 'right',
          msg: '',
          grade: 0,
          isPlaying: false,
          isAskLuyin: false,
          // 口语表达新增参数
          sysUrl: data.extra.audio_url,
          sysText: !this.exchangeType ? data.extra.english_text : data.option,
          expressionType: 1, // 是口语表达
          nowExchangeType: this.exchangeType,
          hasTip: data.extra.prompt_content
        }
        this.messageList.push(obj)
      } else {
        const obj = {
          id: new Date().getTime() + Math.random(),
          url: '',
          audio_duration: data.extra.audio_duration,
          avatar_url: this.userInfo.avatar_url,
          avatar_name: data.extra.avatar_name,
          isVip: false,
          type: 'right',
          isPlaying: false,
          isAskLuyin: false,
          // 口语表达新增参数
          sysUrl: data.extra.audio_url,
          sysText: !this.exchangeType ? data.extra.english_text : data.option,
          expressionType: 1, // 是口语表达
          nowExchangeType: this.exchangeType,
          hasTip: data.extra.prompt_content
        }
        this.messageList.push(obj)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.conten-box {
  height: 100%;
  font-family: PingFangSC-Medium, PingFang SC;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .header {
    /deep/ .van-nav-bar__title {
      font-size: 16px;
      font-weight: bold;
      color: rgba(69, 70, 74, 1);
    }

    /deep/ .van-icon {
      &:active {
        background: #f5f5f5;
      }
    }
  }

  .cont {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .progress {
      padding: 0 15px;
      margin-bottom: 20px;
    }

    .wapper {
      flex: 1;
      overflow: auto;

      .w-title {
        padding: 0 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 40px;

        .tag {
          width: 68px;
          height: 25px;
          line-height: 25px;
          text-align: center;
          font-size: 12px;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
          margin-right: 7px;
          background: rgba(116, 118, 125, 1);
          border-radius: 4px;
        }

        .msg {
          display: flex;
          align-items: center;
          font-size: 14px;
          font-weight: bold;
          color: rgba(69, 213, 133, 1);

          &:active {
            opacity: 0.8;
          }

          /deep/ .van-icon {
            margin-right: 2px;
          }
        }
      }

      .msg-box {
        padding: 0 15px;

        .act {
          display: inline-block;
          position: relative;
          left: 50%;
          transform: translateX(-50%);
          margin: 20px 0;
          padding: 4px 15px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 16px;
          background: rgba(164, 167, 176, 1);
          border-radius: 6px;
        }
      }
    }
  }

  .footer {
    height: 140px;
    display: flex;
    align-items: center;
    justify-content: center;

    .footer-item {
      margin-top: 30px;
      user-select: none;

      /deep/ .van-icon {
        &:active {
          opacity: 0.8;
        }
      }

      .name {
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        color: rgba(164, 167, 176, 1);
        margin-top: 22px;
      }

      &:nth-child(2) {
        margin: 0 50px;

        .name {
          margin-top: 0;
        }
      }
    }
  }

  .asklu {
    height: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(53, 63, 79, 0.06);
    padding: 15px 0;
    box-sizing: border-box;
    flex-direction: column;

    .waveBox {
      width: 100%;
      flex: 1;
      overflow: hidden;
      display: flex;
      align-items: center;
    }

    .text {
      font-size: 13px;
      font-family: PingFang-SC-Regular, PingFang-SC;
      font-weight: 400;
      color: rgba(69, 70, 74, 1);
    }
  }

  .player {
    display: none;
  }
}
</style>
